/**
 * ensureBillingKeyframes — injects the billing module's keyframes once.
 *
 * Kept out of a .css import so the components work identically under Vitest
 * (jsdom) without a CSS pipeline. Honors ``prefers-reduced-motion``.
 */

let _injected = false;

export function ensureBillingKeyframes(): void {
  if (_injected) return;
  if (typeof document === "undefined") return;
  if (document.getElementById("__wbm_billing_keyframes")) {
    _injected = true;
    return;
  }
  const style = document.createElement("style");
  style.id = "__wbm_billing_keyframes";
  style.textContent = `
    @keyframes wbm-billing-pop { 0% { transform: scale(0.6); opacity: 0; } 100% { transform: scale(1); opacity: 1; } }
    @keyframes wbm-billing-spin { to { transform: rotate(360deg); } }
    @keyframes wbm-billing-rise { 0% { transform: translateY(14px) scale(.97); opacity: 0; } 100% { transform: none; opacity: 1; } }
    .wbm-billing-spin { display: inline-block; width: 16px; height: 16px; border-radius: 50%;
      border: 2.5px solid rgba(47,58,69,0.25); border-top-color: #2f3a45; animation: wbm-billing-spin .8s linear infinite; }
    @media (prefers-reduced-motion: reduce) {
      .wbm-billing-spin { animation: none; }
      [data-wbm-rise] { animation: none !important; }
      [data-wbm-pop] { animation: none !important; }
    }
  `;
  document.head.appendChild(style);
  _injected = true;
}
